"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAppNotifications = void 0;
const vue_1 = require("vue");
const injection_symbols_1 = require("./injection-symbols");
const app_notifications_1 = require("./app-notifications");
function useAppNotifications() {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const globalAppNotifications = (0, vue_1.inject)(injection_symbols_1.appNotificationsKey);
    return (0, app_notifications_1.createAppNotifications)({
        notifications: globalAppNotifications._getRawNotifications()
    });
}
exports.useAppNotifications = useAppNotifications;
//# sourceMappingURL=use-api.js.map